__webpack_require__.p = "/views-skeletons/referrals-hub/";